import { render, staticRenderFns } from "./CodigosList.vue?vue&type=template&id=8c777be2&"
import script from "./CodigosList.vue?vue&type=script&lang=js&"
export * from "./CodigosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports